export default "__VITE_ASSET__BogD7v_f__"